import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Experiencia } from 'src/app/interfaces/experiencia';
import { Response } from 'src/app/interfaces/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExperienciaService {

  private baseApiUrl = environment.baseApi + '/privado/experiencia';

  constructor(private httpClient: HttpClient) { }

  async obtenerExperienciasPorIdCandidato(idCandidato: number){
    return await this.httpClient.get<Response>(`${this.baseApiUrl}/${idCandidato}`).toPromise();
  }

  registrarExperiencia(idCandidato:number, body: Experiencia): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<Response>(`${this.baseApiUrl}/${idCandidato}`, body, { headers });
  }

  actualizarExperiencia(body: Experiencia): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.put<Response>(`${this.baseApiUrl}`, body, { headers });
  }

  eliminarExperienciaPorId(idCandidato: number, idEscolaridad: number): Observable<Response> {
    return this.httpClient.delete<Response>(`${this.baseApiUrl}/${idCandidato}/${idEscolaridad}`);
  }
}
